import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../../components/layout'
import parse from 'html-react-parser'
import QuoteSection from './Quote'
import Video from './Video'
import './style.scss'
// import SideContent from './SideContent'
import BottomContent from './BottomContent'
import ContactForm from '../../components/ContactForm/ContactForm'
import Spacer from '../../components/Spacer/Spacer'
import Seo from '../../components/seo'
import HeroIconBlock from '../../components/HeroIconBlock/HeroIconBlock'
import WYSIWYGBlock from '../../components/WYSIWYGBlock/WYSIWYGBlock'
import StatisticBlock from '../../components/StatisticBlock/StatisticBlock'
import SimpleVideoBlock from '../../components/SimpleVideoBlock/SimpleVideoBlock'
import TitleIconBlock from '../../components/TitleIconBlock/TitleIconBlock'
import SocialMediaBlock from '../../components/SocialMediaBlock/SocialMediaBlock'
import ClientHero from '../../components/ClientHero/ClientHero'
import ClientTestimonial from '../../components/ClientTestimonial/ClientTestimonial'
import ClientSummary from '../../components/ClientSummary/ClientSummary'

const dynamicBlocks = {
    'acf/hubspot-form': ContactForm,
    'acf/quote-section': QuoteSection,
    'acf/video-preview': Video,
    'acf/hero-icon-block': HeroIconBlock,
    'acf/wysiwyg-block': WYSIWYGBlock,
    'acf/statistic-block': StatisticBlock,
    'core/video': SimpleVideoBlock,
    'acf/title-icon-block': TitleIconBlock,
    'acf/social-media-block': SocialMediaBlock,
    'acf/client-hero-block': ClientHero,
    'acf/testimonial-block': ClientTestimonial,
    'acf/client-summary-block': ClientSummary
}

const ContainerWrapper = ({ children }) => {
    return (
        <div className="grid grid-cols-12 container [&_.container]:px-0">
            <div className="client-content col-span-12 lg:col-span-8 lg:col-start-3">
                {children}
            </div>
        </div>
    )
}

function ClientSingle({ data, pageContext }) {
    const content = data?.wpClient?.blocks
    const relatedCase = content.filter((node) => {
        return node.name === 'acf/client-cards'
    })[0] || []
    const latestBlock = content.filter((node) => {
        return node.name === 'acf/basic-block'
    })

    // If have hero component, remove the title of the client page
    const heroHeading = content.some((node) => {
        const hasHeroBlock = [
            'acf/hero-icon-block',
            'acf/client-hero-block'
        ].includes(node?.name)

        return hasHeroBlock
    })

    // Create this one to apply the new components which have different layout from the old ones
    const newComponents = [
        'acf/client-hero-block',
        'acf/testimonial-block',
        'acf/client-summary-block'
    ]

    const hasNewHeroBlock = content?.[0]?.name === 'acf/client-hero-block'
    return (
        <Layout mode={'dark'}>
            <div
                className={`${
                    hasNewHeroBlock ? '' : 'mt-12 lg:mt-[164px]'
                }`}
            >
                <div className="">
                    {!heroHeading && (
                        <ContainerWrapper>
                            <h1 className="mb-5 text-[42px] leading-[42px] xl:text-[60px] xl:leading-[62px]">
                                {data?.wpClient?.title}
                            </h1>
                        </ContainerWrapper>
                    )}

                    {content.map((node, index) => {
                        if (Boolean(dynamicBlocks[node?.name])) {
                            const Component = dynamicBlocks[node?.name]
                            if (newComponents.includes(node?.name)) {
                                return (
                                    <div key={index} className={'col-span-12'}>
                                        <Component {...node} />
                                    </div>
                                )
                            }

                            return (
                                <ContainerWrapper key={index}>
                                    <Component {...node} />
                                </ContainerWrapper>
                            )
                        }

                        if (node.name === 'acf/spacer') {
                            return <Spacer spacer={node.spacer} />
                        }

                        if (node.name === 'core/list') {
                            const type = node.originalContent.slice(1, 3)

                            if (type === 'ul') {
                                return (
                                    <ContainerWrapper key={index}>
                                        <ul>
                                            {node.innerBlocks.map((item) => {
                                                return (
                                                    <li>
                                                        {item.originalContent &&
                                                            parse(
                                                                item.originalContent
                                                            )}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </ContainerWrapper>
                                )
                            } else {
                                return (
                                    <ContainerWrapper key={index}>
                                        <ol>
                                            {node.innerBlocks.map((item) => {
                                                return (
                                                    <li>
                                                        {item.originalContent &&
                                                            parse(
                                                                item.originalContent
                                                            )}
                                                    </li>
                                                )
                                            })}
                                        </ol>
                                    </ContainerWrapper>
                                )
                            }
                        }

                        return (
                            <ContainerWrapper key={index}>
                                {parse(node.originalContent)}
                            </ContainerWrapper>
                        )
                    })}
                </div>
                <BottomContent
                    relatedCase={relatedCase}
                    latestBlock={latestBlock}
                />
            </div>
        </Layout>
    )
}
export const Head = ({ data }) => {
    const { seo, title, excerpt, featuredImage } = data?.yoastSeo
    const metaDesc =
        seo?.metaDesc ||
        excerpt.replace(/<[^>]*>/g, '') ||
        `Celerity client | ${title}`
    return (
        <Seo
            title={seo?.title}
            description={metaDesc}
            image={featuredImage?.node?.sourceUrl}
            props={seo}
        />
    )
}
export const pageQuery = graphql`
    query ($id: String!) {
        wpClient(id: { eq: $id }) {
            title
            solutions {
                nodes {
                  name
                }
            }
            featuredImage {
                node {
                    ...image
                }
            }
            clientLogo {
                clientLogo {
                    ...image
                }
            }
            ...ClientLayout
        }
        yoastSeo: wpClient(id: { eq: $id }) {
            featuredImage {
                node {
                    ...image
                }
            }
            title
            excerpt
            seo {
                title
                canonical
                metaDesc
                focuskw
                opengraphTitle
                opengraphDescription
                twitterTitle
                twitterDescription
            }
        }
    }
`
export default ClientSingle
